(() => {
  const root = document.documentElement;
  const key = 'bts-shop-curtain';
  let navigating = false;
  let navigationTimer;
  const reset = () => {
    clearTimeout(navigationTimer);
    clearTimeout(window.btsCurtainSafety);
    root.classList.remove('bts-curtain-active', 'bts-curtain-closed', 'bts-curtain-arriving');
    navigating = false;
  };

  if (root.classList.contains('bts-curtain-arriving')) {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      root.classList.remove('bts-curtain-arriving');
      // Pause on the closed wooden doors, then reveal the product page.
      setTimeout(() => {
        root.classList.remove('bts-curtain-closed');
        setTimeout(reset, 720);
      }, 72);
    }));
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-bts-shop-curtain]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin) return;
    event.preventDefault();
    if (navigating) return;
    navigating = true;
    root.classList.add('bts-curtain-active');
    // Commit the offscreen position before starting both inward-moving halves.
    getComputedStyle(root, '::before').transform;
    requestAnimationFrame(() => {
      root.classList.add('bts-curtain-closed');
      navigationTimer = setTimeout(() => {
        try {
          sessionStorage.setItem(key, JSON.stringify({ path: destination.pathname, time: Date.now() }));
        } catch (_) { /* The link still works without session storage. */ }
        location.assign(destination.href);
        window.btsCurtainSafety = setTimeout(reset, 8000);
      }, 752); // 680ms closing motion + 72ms closed-door pause.
    });
  });

  // A restored homepage must not retain its departing door overlay.
  window.addEventListener('pageshow', event => { if (event.persisted) reset(); });
})();
